import { createApp } from 'vue';
import { createPinia } from 'pinia';
import vSelect from 'vue-select';
import Maska from 'maska';
import AppWrapper from '../src/App.vue';

const MarOps = {
  load: (formConfig) => {
    const libWrapper = AppWrapper(formConfig);
    const formApp = createApp(libWrapper);
    formApp.use(createPinia());
    formApp.use(Maska);
    formApp.component('vSelect', vSelect);
    formApp.mount('#marops');
  },
};

export default MarOps;
